/*global Modernizr, Splide */
/*jslint browser:true */

function TLASlideCurrentSlide(Splide) {
  'use strict';

  let currentSlide = false;

  function mount() {
    if(Splide.root.querySelector('.splide__arrows') && !Splide.root.querySelector('.splide__arrows').hasAttribute('data-show-status')) {
      currentSlide = document.createElement('div');

      currentSlide.setAttribute('aria-live', 'polite');
      currentSlide.setAttribute('aria-atomic', 'true');
      currentSlide.classList.add('slider-status');

      currentSlide.textContent = `${ Splide.index + 1 }/${ Splide.length }`;

      Splide.root.querySelector('.splide__arrows').appendChild(currentSlide);
      Splide.on('moved', onMoved);
    }
  }

  function onMoved() {
    if(currentSlide) {
      currentSlide.textContent = `${ Splide.index + 1 }/${ Splide.length }`;
    }
  }

  function destroy() {
    if(currentSlide) {
      Splide.root.removeChild(currentSlide);
    }
  }

  return {
    mount,
    destroy,
  };
}

function TLASlideHideArrows(Splide) {
  'use strict';

  function mount() {
    Splide.on('mounted resize', () => {
      if(Splide.length <= Splide.options.perPage) {
        Splide.root.querySelector('.splide__arrows').classList.add('hidden');
      } else {
        Splide.root.querySelector('.splide__arrows').classList.remove('hidden');
      }
    });
  }

  return {
    mount
  };
}

function TLASlideDisableDrag(Splide) {
  'use strict';

  function mount() {
    if(Splide.length === 1) {
      Splide.options = {drag: false};
    }
  }

  return {
    mount
  };
}